import { Slider as AntdSlider, SliderSingleProps } from 'antd';

import * as S from './styles';

export type SliderProps = SliderSingleProps;

const Slider = (props: SliderProps) => (
  <S.Wrapper>
    <AntdSlider
      tooltip={{
        open: false,
      }}
      {...props}
    />
  </S.Wrapper>
);

export default Slider;
